<div class="container" *ngIf="project">
  <div class="row py-5">
    <div
      class="col-md-6 d-flex justify-content-center align-items-center flex-column gap-5 mt-4"
    >
      <p class="m-0 fs-3 fw-bold">
        {{ "About Project" | translate }}
      </p>
      <a
        [href]="project.link"
        target="_blank"
        class="text-decoration-none text-black fs-3 fw-normal"
        >{{ project.link }}</a
      >
      <p class="m-0 text-center">
        {{ project.about | translate }}
      </p>
    </div>
    <div class="col-md-6 mt-4">
      <img [src]="project.websitePhoto" class="w-100" alt="" />
    </div>
    <div class="col-md-6 d-flex flex-column gap-2 mt-md-5 mt-2">
      <img [src]="project.mobilePhoto" alt="" />
      <div class="d-flex justify-content-center gap-2">
        <a href="">
          <img src="../../../assets/images/app-store.png" alt="" width="100" />
        </a>
        <a href="">
          <img
            src="../../../assets/images/google-play.png"
            alt=""
            width="100"
          />
        </a>
      </div>
    </div>
    <div class="col-md-6 mt-md-5 mt-0">
      <div class="row pt-4">
        <div class="col-12 d-flex gap-3 align-items-center mb-3">
          <div class="pink-square"></div>
          <p class="m-0 text-pink fs-4">{{ "specifications" | translate }}</p>
        </div>
        <div class="col-12 d-flex">
          <p class="m-0 px-1 text-start">
            {{ project.specifications | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-12 mt-5 px-md-5 px-2">
      <h2 class="text-pink fw-bold text-center">
        {{ "what do we present you" | translate }}
      </h2>
      <p class="text-center">{{ project.presents | translate}}</p>
    </div>
    <div class="col-12">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let slide of project.sliderImages">
          <ng-template carouselSlide>
            <div
              class="image-box mx-auto d-flex justify-content-center align-items-center overflow-hidden"
            >
              <img
                [src]="slide"
                class="p-4 w-100"
              />
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</div>
